// This function will be used to get the current state from Redux
// The actual implementation will be in components that need this data
export const getShowEdmontonData = () => {
  // This will be overridden by components that have access to Redux state
  return false;
};

// Legacy export for backward compatibility
export const showEdmontonData = false;
export const enableMapFiltering = false;